import React from "react";
import Icon from "components/AppIcon";

const pillars = [
  {
    icon: "Award",
    title: "Your Experience Has Real Value",
    body: "Decades of professional work have given you pattern recognition, judgment, and domain knowledge that cannot be replicated by someone starting fresh. These are not soft advantages — they are hard economic assets.",
  },
  {
    icon: "Bot",
    title: "AI Is Leverage, Not a Replacement",
    body: "AI tools amplify what you already know. They handle the repetitive, the mechanical, the time-consuming. You provide the wisdom, the context, and the human judgment that makes the output actually useful.",
  },
  {
    icon: "Footprints",
    title: "Small Execution Beats Overthinking",
    body: "The professionals who succeed in this transition are not the ones who plan the most — they are the ones who start the smallest viable version and refine from there. One client. One offer. One week at a time.",
  },
];

const StrategicEncouragement = () => {
  return (
    <section className="rounded-2xl border shadow-sm p-6 md:p-8 lg:p-10" style={{ backgroundColor: "var(--color-surface)", borderColor: "var(--color-border)" }}>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "rgba(211,172,53,0.12)" }}>
          <Icon name="Compass" size={22} color="var(--color-accent)" strokeWidth={2} />
        </div>
        <div>
          <p className="text-xs font-medium uppercase tracking-widest" style={{ color: "var(--color-accent)", fontFamily: "var(--font-caption)" }}>Section 5</p>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>Strategic Encouragement</h2>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {pillars?.map((pillar, idx) => (
          <div key={idx} className="bg-white rounded-xl p-5 border flex flex-col gap-3" style={{ borderColor: "var(--color-border)" }}>
            <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: "rgba(40,59,163,0.08)" }}>
              <Icon name={pillar?.icon} size={20} color="var(--color-primary)" strokeWidth={2} />
            </div>
            <h3 className="text-sm md:text-base font-bold" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)", fontWeight: 700 }}>{pillar?.title}</h3>
            <p className="text-sm leading-relaxed" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-body)" }}>{pillar?.body}</p>
          </div>
        ))}
      </div>
      <div className="mt-6 p-5 rounded-xl border-l-4 bg-white" style={{ borderLeftColor: "var(--color-accent)" }}>
        <p className="text-base md:text-lg font-semibold italic" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
          &ldquo;The goal is not to become a tech expert. The goal is to use technology as a tool — the same way you have used every other tool throughout your career.&rdquo;
        </p>
        <p className="text-sm mt-2" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>— QuantuMe Prospectus Strategic Principle</p>
      </div>
    </section>
  );
};

export default StrategicEncouragement;